"use strict";
class AuthAction {
    constructor(name, service, authResult) {
        this.name = name;
        this.service = service;
        this.authResult = authResult;
    }
}
exports.AuthAction = AuthAction;
